import { useEffect, useState } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import BreedSection from "@/components/BreedSection";
import BreedingSection from "@/components/BreedingSection";
import CatsSection from "@/components/CatsSection";
import LittersSection from "@/components/LittersSection";
import AlumniSection from "@/components/AlumniSection";
import BlogSection from "@/components/BlogSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import AdoptionSection from "@/components/AdoptionSection";
import WhyUsSection from "@/components/WhyUsSection";
import TipsSection from "@/components/TipsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { trackPageview, trackSection } from "@/lib/analytics";

const TRACKED_SECTIONS = ['race', 'elevage', 'chats', 'alumni', 'portees', 'blog', 'temoignages', 'adoption', 'contact'];

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    trackPageview();
    
    const trackedSections = new Set();

    // Intersection Observer for scroll animations + analytics
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            // Track section view
            const id = entry.target.id;
            if (id && TRACKED_SECTIONS.includes(id) && !trackedSections.has(id)) {
              trackedSections.add(id);
              trackSection(id);
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    const observeAll = () => {
      document.querySelectorAll(".section-animate:not(.observed)").forEach((el) => {
        el.classList.add("observed");
        observer.observe(el);
      });
    };

    observeAll();

    // Watch for dynamically added elements (API-loaded content)
    const mutationObs = new MutationObserver(observeAll);
    mutationObs.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObs.disconnect();
    };
  }, []);

  return (
    <div className={`min-h-screen bg-cream transition-opacity duration-500 ${isLoaded ? "opacity-100" : "opacity-0"}`}>
      <Navigation />
      <main>
        <HeroSection />
        <BreedSection />
        <BreedingSection />
        <CatsSection />
        <AlumniSection />
        <LittersSection />
        <BlogSection />
        <TestimonialsSection />
        <AdoptionSection />
        <WhyUsSection />
        <TipsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
